<template>
    <div class="Pagination flex justify-center items-center">
        <!-- v-model="page" -->
        <v-pagination v-if="total_pages > 1" :pages="total_pages" :range-size="1" active-color="#fe5000"
            :hideFirstButton="true" :hideLastButton="true" v-model="currentPage" @update:modelValue="updateHandler">
            <!-- Custom Previous Button -->
            <template #prev-button>
                <button class="PaginationControl">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                    </svg>
                </button>
            </template>
                
            <!-- Custom Next Button -->
            <template #next-button>
                <button class="PaginationControl active">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                </button>
            </template>
        </v-pagination>
    </div>
</template>

<script>
import VPagination from "@hennge/vue3-pagination";
// import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {

    components: {
        VPagination
    },
    props: ["page", "total_pages", "updatePage"],
    data() {
        return {
            currentPage: this.page // initialize from prop
        };
    },
    watch: {
        page(newVal) {
            this.currentPage = newVal; // keep in sync if parent updates it
        }
    },
    methods: {
        updateHandler(value) {

            this.currentPage = value;
            this.updatePage(value)

        }
    }
};
</script>
